module.exports = __webpack_public_path__ + "img/zamowienia_inactive.f6420d7a.svg";